import React, { useState } from 'react';
import { Button } from 'carbon-components-react';
import { UpgradeModal } from 'components';

const UpgradePlan: React.FC<Props> = ({ source }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  return (
    <>
      <div className="upgrade-plan-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">
          Enjoying the free plan?
        </div>
      </div>
      <div className="upgrade-plan-button-container">
        <Button
          className="upgrade-plan-button"
          kind="tertiary"
          onClick={() => setIsModalOpen(true)}
        >
          Upgrade my plan
        </Button>
      </div>
      <UpgradeModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        source={source}
      />
    </>
  );
};

type Props = {
  source?: string;
};

export default React.memo(UpgradePlan);
